import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { invoiceItem } from '../../types/invoice';
import { InvoiceService } from '../../services/invoice/invoice.service';
import { finalize } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { DropdownChangeEvent } from 'primeng/dropdown';

@Component({
  selector: 'app-invoice-contact-list',
  templateUrl: './invoice-contact-list.component.html',
  styleUrl: './invoice-contact-list.component.scss',
  providers: [ConfirmationService]
})
export class InvoiceContactListComponent {

  @Input() module!: string;
  @Input() locator: any;
  @Input() location!: string;
  @Input() suite!: string;
  @Input() account!: string;
  @Input() types!: string;

  displayContactModal: boolean = false;
  tenantContacts: any[] = [];
  loadingTenantContacts: boolean = false;

  ARTypeOptions: any[] = [
    { code: "Monthly", name: "Monthly" },
    { code: "Validation", name: "Validation" },
    { code: "Key Card", name: "Key Card" },
    { code: "Special", name: "Special" }
  ];

  states = ["AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VI", "VA", "WA", "WV", "WI", "WY"];
  availableLineItemsOptions!: invoiceItem[];
  allowedSectionOptions: any[] = [];
  availableAccessLevelOptions: any[] = [];
  availableKeycardActions: string[] = ['Add', 'Terminate', 'Check'];

  availableLineItemsData: any;

  invoiceContactForm!: FormGroup;
  editingContactIndex!: number;

  selectedKeycardAction: string | undefined = undefined;
  wpsStatusMsg: string = '';
  wpsSpinnerVisible: boolean = true;

  constructor(
    private fb: FormBuilder,
    private invoiceService: InvoiceService,
    private confirmationService: ConfirmationService) { }

  ngOnInit(): void {

    // If not set then get the tag properties
    if (typeof this.locator === 'undefined') {
      this.locator = {
        location: this.location,
        suite: this.suite,
        account: this.account,
      };
    }

    if (this.module == "tenant") {

      this.invoiceService.getTenant(this.locator.location, this.locator.suite, this.locator.account).subscribe((data: any) => {
        let availableLineItems = [];

        let counter = 0;

        let available_invoice_items = data.data.available_invoice_items;

        // If the unitprice is already formatted then remove the currency formatting
        available_invoice_items.forEach((v: any) => {
          v.unitprice = this.stripCurrency(v.unitprice);
        });

        availableLineItems.push({
          value: 'Please select a parking service',
          label: 'Please select a parking service',
        })
        counter += 1;

        for (let item of data.data.available_invoice_items) {
          // We only want to make invoices for items which are not monthly parking services.
          if (item.type.toUpperCase() !== this.types) {

            availableLineItems.push({
              code: item.code,
              value: item.description,
              label: item.description,
              type: item.type,

            });

            counter += 1;
          }
        }

        let lineItemsData = Object.assign({}, data.data);
        lineItemsData['availableLineItems'] = availableLineItems;
        this.availableLineItemsOptions = lineItemsData['availableLineItems'];
        this.availableLineItemsData = lineItemsData;
        Object.keys(this.availableLineItemsData.allowed_sections).map((key) => { this.allowedSectionOptions.push(this.availableLineItemsData.allowed_sections[key]); });
        Object.keys(this.availableLineItemsData.available_access_levels).map((key) => { this.availableAccessLevelOptions.push(this.availableLineItemsData.available_access_levels[key]); });

        if (this.availableLineItemsData['parking_device'] != 'wps') {
          this.availableKeycardActions = [
            'Add',
            'Terminate',
            'Check',
            'Unlink From Device'
          ]
        }

        this.getContacts();

      });
    }

    this.invoiceService.currentTenantData.subscribe((availableLineItems: any) => {
      if (availableLineItems) {
        console.log(availableLineItems)
        this.availableLineItemsOptions = availableLineItems['availableLineItems'];
        this.availableLineItemsData = availableLineItems;

        this.getContacts();
      }
    })

    this.invoiceContactForm = this.fb.group({
      contactFirstName: [''],
      contactLastName: [''],
      description: [''],
      phones: [''],
      emails: [''],
      extensions: [''],
      make: [''],
      model: [''],
      year: [''],
      color: [''],
      plate: [''],
      state: [''],
      effectiveDates: [''],
      terminationDates: [''],
      facility_code: [''],
      keycards: [''],
      rate_desc: [''],
      ar_type: [''],
      access_level: [''],
      section: [''],
      keycard_active: [false]
    });

  }

  getContacts(): void {

    this.loadingTenantContacts = true;

    this.invoiceService.getTenantContacts(this.locator.location, this.locator.suite, this.locator.account)
      .pipe(finalize(() => { this.loadingTenantContacts = false; }))
      .subscribe((data: any) => {
        if (data) {
          this.tenantContacts = data.map((contact: any, index: number) => {
            contact['pos'] = index + 1;

            if (typeof contact.rate == 'undefined') {
              contact.rate = '';
              contact.rate_desc = '';
              contact.rate_amount = 0;
              contact.ar_type = '';
            } else {
              let line_item = this.rateCodeDetails(contact.rate);

              if (line_item !== null) {
                contact.rate = contact.rate;
                contact.rate_desc = line_item.description;
                contact.ar_type = contact.ar_type;
                contact.rate_amount = this.stripCurrency(line_item.unitprice);
                // vm.invoice_items_total = parseFloat( contact.rate_amount) + parseFloat(vm.invoice_items_total);
              } else {
                contact.rate = '';
                contact.rate_desc = '';
                contact.ar_type = '';
                contact.rate_amount = 0;
              }

              if (typeof contact.rate_desc == 'undefined') {
                contact.rate_desc = '';
              }

              if (typeof contact.ar_type == 'undefined') {
                contact.ar_type = '';
              }

              if (typeof contact.user_selected == 'undefined') {
                contact.user_selected = false;
              } else {
                contact.user_selected = contact.user_selected;
              }

              if (typeof contact.access_level == 'undefined') {
                contact.access_level = '';
                contact.access_level_disp = '';
              } else {
                contact.access_level = contact.access_level;
                contact.access_level_disp = this.accessCodeDetails(contact.access_level);
              }

              if (typeof contact.rate_amount == 'undefined') {
                contact.rate_amount = '0';
              }

              let infoDisp = contact.phones + ' ' + contact.extensions + '<br/>' + contact.emails + '<br/>' + contact.description;
              contact.infoDisplay = infoDisp;

              contact.line_num = index;

            }
            return contact;
          });
        }

      });
  }

  accessCodeDetails(code: string) {
    for (let key in this.availableLineItemsData.available_access_levels) {
      if (code === key) {
        return this.availableLineItemsData.available_access_levels[key];
      }
    }
    return null;
  }

  private rateCodeDetails(code: string) {
    for (let i = 0; i < this.availableLineItemsData['available_invoice_items'].length; i++) {
      let line_item = this.availableLineItemsData['available_invoice_items'][i];

      if (line_item['code'] == code) {
        return line_item;
      }
    }
    return null;
  }

  private stripCurrency(val: any) {

    if (!isNaN(val)) {
      //Already a number
      return val;
    }

    val = val.trim();
    val = val.replace(/,/g, '');
    let chunk = val.slice(0, 1);
    if (chunk == "$") {
      return val.slice(1);
    }
  }

  private arDescDetails(description: string) {
    for (let prop in this.availableLineItemsData.available_ar_types) {

      if (this.availableLineItemsData.available_ar_types[prop] == description) {
        return prop;
      }
    }
    return null;
  }

  accessDescDetails(description: string) {
    for (let key in this.availableLineItemsData.available_access_levels) {
      if (description == this.availableLineItemsData.available_access_levels[key]) {
        return key;
      }
    }
    return null
  }

  /**
   * Given a section code description return the key
   */
  sectionDescDetails(description: string) {
    for (let key in this.availableLineItemsData.allowed_sections) {
      if (description == this.availableLineItemsData.allowed_sections[key]) {
        return key;
      }
    }
    return null
  }

  rateDescDetails(description: string) {
    for (let i = 0; i < this.availableLineItemsData.available_invoice_items.length; i++) {
      let line_item = this.availableLineItemsData.available_invoice_items[i];
      if (line_item['description'] == description) {
        return line_item;
      }
    }

    return null;
  }

  editContact(index: number): void {
    this.displayContactModal = true;

    let contactData = this.tenantContacts[index];
    this.editingContactIndex = index;

    let contactFirstName = '';
    let contactLastName = '';

    if (typeof contactData['contactName'] !== 'undefined') {
      let contactNameArr = contactData['contactName'].split(" ");
      if (contactNameArr.length) {
        contactFirstName = contactNameArr[0];
        contactLastName = contactNameArr[1] || '';
      }

    }

    this.invoiceContactForm.controls['contactFirstName'].setValue(contactFirstName);
    this.invoiceContactForm.controls['contactLastName'].setValue(contactLastName);

    this.invoiceContactForm.controls['description'].setValue(contactData['description']);
    this.invoiceContactForm.controls['phones'].setValue(contactData['phones']);
    this.invoiceContactForm.controls['emails'].setValue(contactData['emails']);
    this.invoiceContactForm.controls['extensions'].setValue(contactData['extensions']);

    this.invoiceContactForm.controls['make'].setValue(contactData['make']);
    this.invoiceContactForm.controls['model'].setValue(contactData['model']);
    this.invoiceContactForm.controls['year'].setValue(contactData['year']);
    this.invoiceContactForm.controls['color'].setValue(contactData['color']);
    this.invoiceContactForm.controls['plate'].setValue(contactData['plate']);
    this.invoiceContactForm.controls['state'].setValue(contactData['state']);

    this.invoiceContactForm.controls['effectiveDates'].setValue(contactData['effectiveDates']);
    this.invoiceContactForm.controls['terminationDates'].setValue(contactData['terminationDates']);
    this.invoiceContactForm.controls['facility_code'].setValue(contactData['facility_code']);
    this.invoiceContactForm.controls['keycards'].setValue(contactData['keycards']);
    this.invoiceContactForm.controls['rate_desc'].setValue(contactData['rate_desc']);
    this.invoiceContactForm.controls['ar_type'].setValue(contactData['ar_type']);
    this.invoiceContactForm.controls['access_level'].setValue(contactData['access_level']);
    this.invoiceContactForm.controls['section'].setValue(contactData['section'] || '');


    this.selectedKeycardAction = undefined;
    this.wpsSpinnerVisible = false;

    this.getWPSState();

  }

  showContactModal(): void {
    this.editingContactIndex = -1;
    this.displayContactModal = true;
  }

  saveContact(): void {
    let contactDetails = this.invoiceContactForm.value;
    if (contactDetails['effectiveDates']) {
      contactDetails['effectiveDates'] = this.formatDate(contactDetails['effectiveDates']);
    }
    if (contactDetails['terminationDates']) {
      contactDetails['terminationDates'] = this.formatDate(contactDetails['terminationDates']);
    }

    let infoDisp = contactDetails['phones'] + ' ' + contactDetails['extensions'] + '<br/>' + contactDetails['emails'] + '<br/>' + contactDetails['description'];
    contactDetails['infoDisplay'] = infoDisp;

    if (typeof contactDetails.terminationDates === 'undefined') {
      contactDetails.terminationDates = '';
    }

    if (typeof contactDetails.effectiveDates === 'undefined') {
      contactDetails.effectiveDates = '';
    }

    // Turn the selected AR description back into an array index
    let line_ar_type = this.arDescDetails(contactDetails.ar_type);
    let ar_type_code = (line_ar_type === undefined || line_ar_type === null) ? '' : line_ar_type;

    contactDetails.access_level_disp = contactDetails.access_level;
    //Convert the access description back into a code for transmission
    let line_item_code = this.accessDescDetails(contactDetails.access_level);
    contactDetails.access_level = line_item_code;

    // Turn the selected description back into the array index
    let line_item_rate_desc = this.rateDescDetails(contactDetails.rate_desc || '');
    let line_item_rate_desc_code = (line_item_rate_desc === undefined || line_item_rate_desc === null) ? '' : line_item_rate_desc.code;
    contactDetails.rate = line_item_rate_desc_code;

    if (line_item_rate_desc_code == '') {
      contactDetails.rate_desc = '';
      contactDetails.rate_amount = 0.00;
      contactDetails.ar_type = '';

      // if (isNewContact && !limitedValidation) {
      //   // New contacts have additional validation
      //   this.errors.push('A rate is required');
      // }


    } else {
      contactDetails.rate_desc = (line_item_rate_desc.description === undefined) ? '' : line_item_rate_desc.description;
      contactDetails.rate_amount = this.stripCurrency(line_item_rate_desc.unitprice);
      contactDetails.ar_type = (ar_type_code === undefined) ? '' : ar_type_code;
    }

    if (this.editingContactIndex !== undefined) {
      Object.assign(this.tenantContacts[this.editingContactIndex], contactDetails);
    } else {
      this.tenantContacts.push(contactDetails);
    }

    let params = {
      lid: this.locator.location,
      suite: this.locator.suite,
      account: this.locator.account,
      contacts: this.tenantContacts
    }
    this.invoiceService.saveTenantContacts(params).pipe(finalize(() => {
      this.displayContactModal = false;
      this.editingContactIndex = -1;
    })).subscribe();

  }

  removeContact(index: number, event: Event, mode: string): void {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure you want to delete this surepark item?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.tenantContacts.splice(index, 1);
        let params = {
          lid: this.locator.location,
          suite: this.locator.suite,
          account: this.locator.account,
          contacts: this.tenantContacts,
          mode: mode
        }
        this.invoiceService.saveTenantContacts(params).pipe(finalize(() => { this.displayContactModal = false })).subscribe();
      },
      reject: () => { }
    });

  }

  holdKeycard(index: number, event: Event): void {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure you want to put this keycard on hold?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let date = new Date();
        this.tenantContacts[index]['terminationDates'] = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear();
        this.tenantContacts[index]['rate_desc'] = '';
        this.tenantContacts[index]['rate_amount'] = 0.00;
        this.tenantContacts[index]['ar_type'] = '';
        this.tenantContacts[index]['rate'] = '';
        this.tenantContacts[index]['access_level'] = '';
        this.tenantContacts[index]['access_level_disp'] = '';

        this.updateWPSKeycard(index, "TERMINATED");
      },
      reject: () => { }
    });

  }

  getWPSState() {
    if (!this.availableLineItemsData?.['wps_active']) {
      return;
    }

    this.wpsStatusMsg = ''; //Clear out the status

    this.wpsSpinnerVisible = true;
    this.invoiceContactForm.controls['keycard_active'].setValue(false);

    let facility = this.invoiceContactForm.controls['facility_code'].value;
    let keycard = this.invoiceContactForm.controls['keycards'].value;

    if (this.availableLineItemsData['parking_device'] == 'surepark') {
      // Sure park needs to protect leading zeros
      facility = facility.trim(facility);
      keycard = keycard.trim(keycard);

      if (facility === '' || keycard === '') {
        this.wpsSpinnerVisible = false;
        return
      }

    } else {
      // Leading zeros are not important
      facility = parseInt(facility.trim(facility));
      keycard = parseInt(keycard.trim(keycard));
    }

    this.invoiceService.getWPSState({ facility: facility, keycard: keycard }).subscribe((data: any) => {
      console.log(data)
      if (typeof data.status === 'string' && data.status === 'not found') {
        //State is indeterminate

        //This might be a new keycard, let's see if it is complete
        if (this.invoiceContactForm.controls['facility_code'].value == "" && this.invoiceContactForm.controls['keycards'].value == "") {
          this.wpsStatusMsg = 'The keycard was not found on the parking device and some fields might be missing from ParkPro';
        }
        this.wpsSpinnerVisible = false;
        return;
      }

      if (typeof data.status === 'string' && data.status === 'error') {
        //Don't allow status check because state is indeterminate
        this.wpsSpinnerVisible = false;
        this.wpsStatusMsg = "Error:" + data.error;
        return;
      }

      if (typeof data.data === 'object' && typeof data.data.customerState === 'string') {
        //response looks good

        let state = data.data.customerState;

        if (state == 'ACTIVE') {
          this.wpsStatusMsg = 'They keycard is on the device and ACTIVE.';
          this.invoiceContactForm.controls['keycard_active'].setValue(true);
        } else {
          this.wpsStatusMsg = 'They keycard is on the device and ' + state;
          this.invoiceContactForm.controls['keycard_active'].setValue(false);
        }
      } else {
        this.wpsStatusMsg = 'They keycard could not be checked at this time';
        this.invoiceContactForm.controls['keycard_active'].setValue(false);
      }
      this.wpsSpinnerVisible = false;
    })
  }

  addWPSKeycard() {
    if (!this.availableLineItemsData?.['wps_active']) {
      return;
    }

    this.wpsStatusMsg = ''; //Clear out the status
    this.wpsSpinnerVisible = true;

    let contact_form = this.invoiceContactForm.value;

    let facility = contact_form['facility_code'];
    let keycard = contact_form['keycards'];

    let phone = contact_form['phones'] + ' ' + contact_form['extensions'];

    if (isNaN(facility) || isNaN(keycard)) {
      //This isn't a valid entry, don't check
      this.wpsStatusMsg = "Required fields missing. Can't add.";
      this.selectedKeycardAction = undefined;
      this.wpsSpinnerVisible = false;
      return;
    }

    if (contact_form['section'] === '' && this.availableLineItemsData['parking_device'] === 'wps') {
      this.wpsStatusMsg = 'Section is required when adding a keycard';
      this.selectedKeycardAction = undefined;
      this.wpsSpinnerVisible = false;
      return;
    }

    //This facility and keycard look good so continue the check

    let access_level_id = this.accessDescDetails(contact_form['access_level']);
    let wps_section_id = this.sectionDescDetails(contact_form['section']);

    let firstName = contact_form['contactFirstName'];
    let lastName = contact_form['contactLastName'];

    let contact = {
      contactName: contact_form['contactName'],
      contactFirstName: firstName,
      contactLastName: lastName,
      access_level: access_level_id,
      access_level_disp: '',
      wps_section: wps_section_id,
      customerPhoneNumber: phone,
      facility_code: facility,
      keycards: keycard,
      keycard_active: null,
      section: '',
      aid: (facility + "/" + keycard),
      suite: this.locator.suite,
      account: this.locator.account,
      line_num: this.editingContactIndex,
      selected_action: '',
      description: contact_form['description'],
      phones: phone,
      emails: contact_form['emails'],
      extensions: contact_form['extensions'],
      effectiveDates: this.formatDate(contact_form['effectiveDates']),
      terminationDates: this.formatDate(contact_form['terminationDates']),
      rate: contact_form['rate_desc'],
      make: '',
      model: '',
      year: '',
      plate: '',
      color: '',
    };

    this.invoiceService.addWPSState(contact).subscribe((data: any) => {
      if (typeof data.status === 'string') {

        let status = data.status;
        let error_msg = '';

        if (typeof data.error === 'string') {
          error_msg = data.error;
        }

        if (status === 'success') {
          //Let the user know what's happening
          this.wpsStatusMsg = 'The keycard has been added to the parking device.';
          this.invoiceContactForm.controls['keycard_active'].setValue(true);
        } else {
          let miscmsg = 'They keycard could not be setup due to an error.' + error_msg;
          this.wpsStatusMsg = miscmsg;
          this.invoiceContactForm.controls['keycard_active'].setValue(false);
        }
        this.selectedKeycardAction = undefined;
        this.wpsSpinnerVisible = false;
      }
    });
  }

  updateWPSKeycard(index: number, new_state: string) {

    if (!this.availableLineItemsData?.['wps_active']) {
      this.selectedKeycardAction = undefined;
      this.wpsSpinnerVisible = false;
      return;
    }

    this.wpsSpinnerVisible = true;

    let facility = this.tenantContacts[index]['facility_code'];
    let keycard = this.tenantContacts[index]['keycards'];

    if (facility === '' || keycard === '') {
      this.wpsStatusMsg = "Cannot unlink without a facility code and card number.";
      this.wpsSpinnerVisible = false;
      this.selectedKeycardAction = undefined;

    } else {

      let dataString;

      if (new_state === 'UNLINK') {
        let dataObj = {
          customerState: new_state,
          suite: this.locator.suite,
          account: this.locator.account,
        }

        dataString = dataObj;

      } else {
        dataString = { "customerState": new_state };
      }

      let params = {
        facility: facility,
        keycard: keycard,
        body: dataString
      };

      this.invoiceService.updateWPSState(params).pipe(finalize(() => {
        this.wpsSpinnerVisible = false;
        this.selectedKeycardAction = undefined;
       })).subscribe((resp) => {

        if(resp?.status === 'error' || resp?.status === 'warning') {
            this.wpsStatusMsg = "Error:" + resp?.error;
            this.invoiceContactForm.controls['keycard_active'].setValue(false);
        } else {
            this.wpsStatusMsg = "Updated...";

            let todayDate = new Date();
            let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(todayDate);
            let month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(todayDate);
            let day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(todayDate);

            this.invoiceContactForm.controls['facility_code'].setValue("");
            this.invoiceContactForm.controls['keycards'].setValue("");
            this.invoiceContactForm.controls['terminationDates'].setValue(month + "/" + day + "/" + year);
            this.invoiceContactForm.controls['effectiveDates'].setValue(month + "/" + day + "/" + year);
            this.saveContact();
        }
        this.wpsSpinnerVisible = false;
      });
    }

  }

  wpsChangeState() {
    if (!this.availableLineItemsData?.['wps_active']) {
      return;
    }

    //Clear out the status message before starting another action.
    this.wpsStatusMsg = ''; //Clear out the status

    this.wpsSpinnerVisible = true;

    let facility = this.invoiceContactForm.controls['facility_code'].value;
    facility = parseInt(facility.trim(facility));
    let keycard = this.invoiceContactForm.controls['keycards'].value;
    keycard = parseInt(keycard.trim(keycard));

    if (isNaN(facility) || isNaN(keycard)) {
      //This isn't a valid entry, don't check
      this.wpsStatusMsg = "Required fields missing. Can't change..";
      this.wpsSpinnerVisible = false;
      return;
    }

    let new_state = (this.invoiceContactForm.controls['keycard_active'].value == false) ? 'TERMINATED' : 'ACTIVE';

    let params = {
      facility: facility,
      keycard: keycard,
      body: { "customerState": new_state }
    };

    this.invoiceService.updateWPSState(params).subscribe();
  }

  keycardAction(event: DropdownChangeEvent) {

    switch (event.value) {
      case 'Add':
        this.addWPSKeycard();
        break;
      case 'Check':
        this.getWPSState();
        break;
      case 'Terminate':
        this.updateWPSKeycard(this.editingContactIndex, 'TERMINATED');
        break;
      case 'Unlink From Device':
        this.updateWPSKeycard(this.editingContactIndex, 'UNLINK');
        break;
    }

  }

  toggleActive(event: CheckboxChangeEvent) {
    this.wpsChangeState();
  }

  formatDate(date: string): string {

    if (date == '') { return '' };

    let effectiveDates = new Date(date);
    let year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(effectiveDates);
    let month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(effectiveDates);
    let day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(effectiveDates);

    return month + "/" + day + "/" + year;
  }

  setAsBillingContact() {
    let newContact = structuredClone(this.tenantContacts[this.editingContactIndex]);
    this.tenantContacts.splice(this.editingContactIndex,1);

    let savedCopy = structuredClone(this.tenantContacts[0]);
    this.tenantContacts.splice(0,1);

    //Make it second
    this.tenantContacts.unshift(savedCopy);

    //Add the new item to the beginning
    this.tenantContacts.unshift(newContact);

    let params = {
      lid: this.locator.location,
      suite: this.locator.suite,
      account: this.locator.account,
      contacts: this.tenantContacts,
      contactPos: this.editingContactIndex
    }

    this.invoiceService.saveTenantContacts(params).pipe(finalize(() => {
      this.displayContactModal = false;
      this.editingContactIndex = -1;
    })).subscribe();

  }
}
